export default {
  /**
   * Retrieve cloud auth provider config, either environment specific or if not existing, the
   * @param {*} configs
   * @returns
   */
  getCloudAuthProviderConfig(configs) {
    let features = configs.features;
    let stage = configs.stage;

    // No cloudAuthProvider configured, return with null to use standard login
    if (!features.cloudAuthProvider) return null;

    let config = features.cloudAuthProvider[stage];

    if (!config) {
      console.warn('No cloud config found for stage', stage, 'Recovering by using default');
      config = features.cloudAuthProvider.default;
    }
    return config;
  },
};
